module.exports = __webpack_public_path__ + "static/media/medical-mask.44301e6a.svg";